import { observer } from 'mobx-react-lite';
import React, { useRef} from 'react'
import { useEffect } from 'react';
import PresentationHelper from '../../../js/PresentationHelper';
import AppState from '../../../js/AppState';
import IconButton from '../../shared/IconButton/IconButton';

import button_rewind from '../../../images/icones/button_rewind.png'
import button_pause from '../../../images/icones/button_pause.png'
import button_play from '../../../images/icones/button_play.png'

import './Timeline.css'

const Chapter = ({currentNode, chapterLength, chapterIndex}) => {

  function handleClickElement(i) {
    PresentationHelper.handleTimelineClick(chapterIndex, i)
  }

  const getClass = num => {

    if(chapterIndex < currentNode.chapterIndex) 
      return 'done' 
    else if(chapterIndex === currentNode.chapterIndex)
    {
      if(currentNode.indexInchapter > num)
        return 'done'
      else if(currentNode.indexInchapter === num)
        return 'current'
      else
        return 'next'
    }
    else { 
      return 'next' 
    }
  }

  function getChapterClass() {
    if(chapterIndex < currentNode.chapterIndex) 
      return 'done' 
    else if(chapterIndex === currentNode.chapterIndex)
    {
      return 'current'
    }
    else { 
      return 'next' 
    }
  }

  return (
    <div className={"Chapter " + getChapterClass()} style={{flexGrow: chapterLength}}>
      {
        [...Array(chapterLength)].map((x, i) => <div key={"part"+i} className={"part " + getClass(i)} onClick={() => handleClickElement(i)}></div> )
      }
      <div className="indicator"> { chapterIndex + 1 } </div>
      { chapterIndex === currentNode.chapterIndex && <div className="title"> { PresentationHelper.getCurrentTitle() } </div> }
    </div>
  );
};
 
const Timeline = () => {

  function handlePauseClick(e) {
    e.stopPropagation()
    
    AppState.setPause(!AppState.paused)
  }

  function handleRewindClick(e) {
    e.stopPropagation()

    PresentationHelper.handleRewind()
  }

  return (
    <div className="Timeline">
      <IconButton className={'topbar rewind'} disabled={!PresentationHelper.hasHistory()} onClick={handleRewindClick} icon={button_rewind} />
      <IconButton className={'topbar pause' + (AppState.paused? " paused" : "")} disabled={false}  onClick={handlePauseClick} icon={AppState.paused ? button_play : button_pause} ><h1>{AppState.paused ? "Pause" : ""}</h1></IconButton>


      <div className="Timeline-bar">
      {
        Array.from(PresentationHelper.chapters).map((chap, i) => 
         <Chapter key={"chap"+i} currentNode={ PresentationHelper.currentNode } chapterLength={ chap.nodes.length } chapterIndex={i} />
        )
      }
      {/* <div className='timer'>
        <b>6:45</b> /15:20
      </div> */}
      </div>
    </div>
  );
};

export default observer(Timeline)
